<form (ngSubmit)="validarFormulario(formPersonSearch)" #formPersonSearch="ngForm">
    <div class="card">
        <div 
            class="card-header" 
            *ngIf="!paraCaso && (persona.TipoPersona == 2 || persona.TipoPersona == 3)">
            <h5 *ngIf="origenHistorico === 0">Buscar Clientes</h5>
            <h5 *ngIf="origenHistorico === 1">Buscar Clientes Histórico</h5>
        </div>
        <div class="card-block">
            <div class="row">
                <div class="col-4">
                    <div class="form-group">
                        <label>{{ getNombreEncabezado() }}</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            [placeholder]="getNombreEncabezado()"
                            [(ngModel)]="persona.Nombre"
                            name="Nombre"
                        >
                    </div>
                </div>
                <div class="col-4" *ngIf="!esMoral()">
                    <div class="form-group">
                        <label>Apellido Paterno</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            placeholder='Apellido Paterno'
                            [(ngModel)]="persona.ApellidoPaterno" 
                            name="ApellidoPaterno"
                        >
                    </div>
                </div>
                <div class="col-4" *ngIf="!esMoral()">
                    <div class="form-group">
                        <label>Apellido Materno</label>
                        <input 
                            type="text" class="form-control" 
                            placeholder='Apellido Materno'
                            [(ngModel)]="persona.ApellidoMaterno" 
                            name="ApellidoMaterno"
                        >
                    </div>
                </div>
                <div class="col-4" *ngIf="tipoPersonaCombo == 2 && tipoPersona == 2">
                    <div class=" form-group ">
                        <label for="exampleSelect1 ">Personalidad Fiscal</label>
                        <select 
                            class="form-control " 
                            id="exampleSelect1 " name="PersonalidadFiscal"
                            [(ngModel)]="persona.PersonalidadFiscalId"
                            (ngModelChange)="onPersonalidadFiscalChange()">
                            <option value=-1>Selecciona una Opción</option>
                            <option value="{{ pFiscal.personalidadFiscalId }}"
                                *ngFor="let pFiscal of personalidadFiscal">
                                {{ pFiscal.personalidadFiscal }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-4" *ngIf="tipoPersonaCombo==2 && tipoPersona == 2">
                    <div class="form-group ">
                        <label>R.F.C</label>
                        <input 
                            type="text " 
                            class="form-control " 
                            placeholder='R.F.C' 
                            [(ngModel)]="persona.RFC"
                            name="RFC"
                        >
                    </div>
                </div>
                <div class="col-4" *ngIf=" tipoPersonaCombo==2 && tipoPersona == 2">
                    <div class="form-group ">
                        <label>Número de Cliente</label>
                        <input 
                            type="text " 
                            class="form-control " 
                            placeholder='Número de Cliente'
                            [(ngModel)]="persona.ClaveCia" 
                            name="ClaveCia"
                        >
                    </div>
                </div>
                <div class="col-4" *ngIf="persona.TipoPersona==1">
                    <div class="form-group">
                        <label>Número de Empleado</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            placeholder='Número de Empleado'
                            [(ngModel)]="persona.ClaveCia" name="ClaveCia"
                        >
                    </div>
                </div>
                <div class="col-4" *ngIf="persona.TipoPersona==1">
                    <div class="form-group ">
                        <label>Área</label>
                        <select 
                            class="form-control" 
                            name="AreaId" 
                            id="AreaId" 
                            [(ngModel)]="persona.AreaId">
                            <option value="-1">Selecciona una Opción</option>
                            <option 
                                value="{{ area.areaId}}" 
                                *ngFor="let area of areas"
                            >
                                {{ area.area }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-4" *ngIf="persona.TipoPersona==1">
                    <div class="form-group ">
                        <label>Sucursal</label>
                        <select class="form-control" name="SucursalId" id="SucursalId"
                            [(ngModel)]="persona.SucursalId">
                            <option value="-1">Selecciona una Opción</option>
                            <option 
                                value="{{ sucursal.sucursalId }}" 
                                *ngFor="let sucursal of sucursales">
                                {{sucursal.sucursal }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-8">
                    <h4 class="sub-title">Fecha Registro Desde - Hasta</h4>
                    <div class="row">
                        <div class="col-6">
                            <input 
                                type="date" 
                                class="form-control"
                                [(ngModel)]="persona.FechaInicialRegistro" 
                                name="fechaInicial" 
                            />
                        </div>
                        <div class="col-6">
                            <input 
                                type="date" 
                                class="form-control"
                                [(ngModel)]="persona.FechaFinalRegistro" 
                                name="fechaFinal" 
                            />
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class=" form-group ">
                        <label for="exampleSelect1 ">Estatus</label>
                        <select 
                            class="form-control " 
                            id="exampleSelect1 " 
                            name="EstatusId"
                            [(ngModel)]="persona.EstatusId">
                            <option value=-1>Selecciona una Opción</option>
                            <option value="{{ item.estatusId }}" *ngFor="let item of estatus">
                                {{ item.estatus }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="text-right ">
                <button class="btn btn-info ">Buscar</button>
            </div>
        </div>
    </div>
</form>

<div class="card" >
  <lib-dynamic-table
    [fromSearchButtom]="fromSearchButtom"
    [activeTotalRowsSection]="true"
    [downloadReport]="true" 
    [columns]="columns"
    [data]="data"
    [pageSize]="15"
    [totalRows]="totalrows"
    (action)="onTableAction($event)"
    (newbatch)="onNewBatch($event)"
    (printReport)="onPrintReport()"
    [loadingTotalRows]="loadingTotalRows"></lib-dynamic-table>
</div>